<ion-split-pane contentId="main-content" class="main-content">
  <ion-menu type="overlay" mode="md">
    <ion-header class="ion-no-border">
      <ion-toolbar class="bg-transparent">
        <ion-img src="/assets/images/logo-icon.png"></ion-img>
      </ion-toolbar>

    </ion-header>
    <ion-content class="custom-scrollbar">

      <ion-list id="inbox-list" class="menu-list custom-scrollbar">
        <ion-tab-button [routerLink]="[p.url]" [tab]="p.url" *ngFor="let p of appPages; let i = index"
          [class.color-primary]="rla.isActive" routerLinkActive="active" #rla="routerLinkActive">
          <ion-icon [name]="rla.isActive ? p.icon : p.icon+'-outline'"></ion-icon>
          <ion-label>{{ p.label | translate}}</ion-label>
        </ion-tab-button>
      </ion-list>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>

</ion-split-pane>